import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import firebase from 'firebase/compat/app';
import { ShoppingService } from './shopping.service';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root',
})
export class EventsService {
  private url = environment.urlBackend;
  private urlAdmin = environment.urlBackendAdmin;
  private urlWorker = environment.urlBackendWorker;

  constructor(private http: HttpClient, public shopping: ShoppingService) {}

  public getEvents(date: any, type: any, textFilter: any) {
    return this.http
      .get(this.url + 'events', {
        params: { date, type, textFilter },
      })
      .pipe(
        map((data: any) => {
          return data;
        }),
        catchError((error) => {
          return of(error.error);
        })
      );
  }

  public getEvent(id: any) {
    const idMarketing = this.shopping.getIdMarketing();
    return this.http
      .get(this.url + 'events/' + id, {
        params: { idMarketing },
      })
      .pipe(
        map((data: any) => {
          return data;
        }),
        catchError((error) => {
          return of(error.error);
        })
      );
  }

  public async postEvents(data: any, urlImg: any) {
    const authToken = await firebase!.auth()!.currentUser!.getIdToken();

    const httpOptions = {
      headers: new HttpHeaders({ Authorization: `Bearer ${authToken}` }),
    };

    let dateStart = new Date(data.dateStart);
    dateStart.setUTCHours(
      Number(data.hourStart),
      Number(data.minuteStart),
      0o0,
      0o0
    );
    let dateEnd = new Date(data.dateEnd);
    dateEnd.setUTCHours(Number(data.hourEnd), Number(data.minuteEnd), 0o0, 0o0);

    console.log(data);

    const body = {
      name: data.name,
      type: data.type,
      address: data.address,
      image: urlImg,
      dateStart,
      dateEnd,
      desc: data.desc,
      idMenu: data.idMenu,
      countrie: data.countrie,
      region: data.region,
      commune: data.commune,
    };

    return this.http.post(this.urlAdmin + 'events', body, httpOptions).pipe(
      map((data: any) => {
        return data;
      }),
      catchError((error) => {
        return of(error.error);
      })
    );
  }

  public async getEventAdmin(id: any) {
    const authToken = await firebase!.auth()!.currentUser!.getIdToken();

    const httpOptions = {
      headers: new HttpHeaders({ Authorization: `Bearer ${authToken}` }),
    };

    return this.http.get(this.urlAdmin + 'events/' + id, httpOptions).pipe(
      map((data: any) => {
        return data;
      }),
      catchError((error) => {
        return of(error.error);
      })
    );
  }

  public async getEventsAdmin(date: any, future: any) {
    const authToken = await firebase!.auth()!.currentUser!.getIdToken();

    const httpOptions = {
      headers: new HttpHeaders({ Authorization: `Bearer ${authToken}` }),
    };

    return this.http
      .get(this.urlAdmin + 'events', {
        params: { date, future },
        ...httpOptions,
      })
      .pipe(
        map((data: any) => {
          return data;
        }),
        catchError((error) => {
          return of(error.error);
        })
      );
  }

  public async putPrivateStatusEvent(data: any) {
    const authToken = await firebase!.auth()!.currentUser!.getIdToken();
    const httpOptions = {
      headers: new HttpHeaders({ Authorization: `Bearer ${authToken}` }),
    };

    return this.http
      .put(
        this.urlAdmin + 'events/' + data.id + '/private',
        { ...data },
        httpOptions
      )
      .pipe(
        map((data: any) => {
          return data;
        }),
        catchError((error) => {
          return of(error.error);
        })
      );
  }

  public async putEventWorkersAdmin(id: any, dataUpdate: any) {
    const authToken = await firebase!.auth()!.currentUser!.getIdToken();
    const httpOptions = {
      headers: new HttpHeaders({ Authorization: `Bearer ${authToken}` }),
    };
    return this.http
      .put(
        this.urlAdmin + 'events/' + id + '/workers',
        { workers: dataUpdate },
        httpOptions
      )
      .pipe(
        map((data: any) => {
          return data;
        }),
        catchError((error) => {
          return of(error.error);
        })
      );
  }

  public async putEventCashiersAdmin(id: any, dataUpdate: any) {
    const authToken = await firebase!.auth()!.currentUser!.getIdToken();
    const httpOptions = {
      headers: new HttpHeaders({ Authorization: `Bearer ${authToken}` }),
    };
    return this.http
      .put(
        this.urlAdmin + 'events/' + id + '/cashiers',
        { cashiers: dataUpdate },
        httpOptions
      )
      .pipe(
        map((data: any) => {
          return data;
        }),
        catchError((error) => {
          return of(error.error);
        })
      );
  }

  public async postTicket(data: any, id: any) {
    const authToken = await firebase!.auth()!.currentUser!.getIdToken();

    const httpOptions = {
      headers: new HttpHeaders({ Authorization: `Bearer ${authToken}` }),
    };

    let dateSaleClose = new Date(data.dateSaleClose);
    dateSaleClose.setUTCHours(
      Number(data.hourSaleClose),
      Number(data.minuteSaleClose),
      0o0,
      0o0
    );

    let dateUseClose = new Date(data.dateUseClose);
    dateUseClose.setUTCHours(
      Number(data.hourUseClose),
      Number(data.minuteUseClose),
      0o0,
      0o0
    );

    const body = {
      name: data.name,
      type: data.type,
      price: data.price,
      amount: data.amount,
      desc: data.desc,
      dateSaleClose,
      dateUseClose,
    };

    return this.http
      .post(this.urlAdmin + 'events/' + id + '/tickets', body, httpOptions)
      .pipe(
        map((data: any) => {
          return data;
        }),
        catchError((error) => {
          return of(error.error);
        })
      );
  }

  public async postCodeDescount(data: any, id: any) {
    const authToken = await firebase!.auth()!.currentUser!.getIdToken();

    const httpOptions = {
      headers: new HttpHeaders({ Authorization: `Bearer ${authToken}` }),
    };

    let dateDescountClose = new Date(data.dateDescountClose);
    dateDescountClose.setUTCHours(
      Number(data.hourDescountClose),
      Number(data.minuteDescountClose),
      0o0,
      0o0
    );

    const body = {
      name: data.name,
      code: data.code,
      descount: data.descount,
      amount: data.amount,
      dateDescountClose,
    };

    console.log(body);
    return this.http
      .post(this.urlAdmin + 'events/' + id + '/descounts', body, httpOptions)
      .pipe(
        map((data: any) => {
          return data;
        }),
        catchError((error) => {
          return of(error.error);
        })
      );
  }

  public async putChangeStatusExhausted(dataUpdate: any, eventId: any) {
    const authToken = await firebase!.auth()!.currentUser!.getIdToken();
    const httpOptions = {
      headers: new HttpHeaders({ Authorization: `Bearer ${authToken}` }),
    };
    return this.http
      .put(
        this.urlAdmin +
          'events/' +
          eventId +
          '/tickets/' +
          dataUpdate.uid +
          '/exhausted',
        dataUpdate,
        httpOptions
      )
      .pipe(
        map((data: any) => {
          return data;
        }),
        catchError((error) => {
          return of(error.error);
        })
      );
  }

  public async putChangeStatus(dataUpdate: any, eventId: any) {
    const authToken = await firebase!.auth()!.currentUser!.getIdToken();
    const httpOptions = {
      headers: new HttpHeaders({ Authorization: `Bearer ${authToken}` }),
    };
    return this.http
      .put(
        this.urlAdmin +
          'events/' +
          eventId +
          '/tickets/' +
          dataUpdate.uid +
          '/status',
        dataUpdate,
        httpOptions
      )
      .pipe(
        map((data: any) => {
          return data;
        }),
        catchError((error) => {
          return of(error.error);
        })
      );
  }

  public async postMrketings(data: any, id: any) {
    const authToken = await firebase!.auth()!.currentUser!.getIdToken();

    const httpOptions = {
      headers: new HttpHeaders({ Authorization: `Bearer ${authToken}` }),
    };
    const body = {
      name: data.name,
    };

    return this.http
      .post(this.urlAdmin + 'events/' + id + '/marketings', body, httpOptions)
      .pipe(
        map((data: any) => {
          return data;
        }),
        catchError((error) => {
          return of(error.error);
        })
      );
  }

  // workers

  public async getEventsWorkers() {
    const authToken = await firebase!.auth()!.currentUser!.getIdToken();
    const httpOptions = {
      headers: new HttpHeaders({ Authorization: `Bearer ${authToken}` }),
    };
    return this.http.get(this.urlWorker + 'events', httpOptions).pipe(
      map((data: any) => {
        return data;
      }),
      catchError((error) => {
        return of(error.error);
      })
    );
  }
}
